<template>
    <main class="wrapper">
        <div class="alert alert-danger text-center font-weight-bold" v-if="notSupported">Your browser is not supported.
            Please use a different browser.</div>
        <AppHead />

        <nav id="mainNavbar" class="navbar navbar-light bg-white border-bottom">
            <div class="d-row d-lg-flex align-items-baseline w-100 nav-container">
                <div class="pl-0 d-flex logo-container">
                    <inertia-link class="brand-link" :href="route('dashboard')">
                        <img src="/images/logo.png" alt="MTN Logo" class="brand-image site-logo">
                    </inertia-link>
                </div>

                <!-- Left Links -->
                <div class="navbar-nav-scroll row w-100" id="navbarSupportedContent">
                    <!-- Left Side Of Navbar -->
                    <div class="col-12 col-lg-10">
                        <main-menu />
                    </div>

                    <div class="col-12 col-lg-2 d-flex justify-content-start justify-content-lg-end">
                        <div class="user-panel d-flex align-items-center">
                            <div class="image" v-if="$page.props.user?.profile_photo_url">
                                <img :src="$page.props.user.profile_photo_url" class="img-circle elevation-2"
                                    alt="User Image">
                            </div>

                            <p class="info text-secondary text-nowrap text-size-small mb-0">
                                <i class="fas fa-user"></i>
                                {{ $page.props.auth.user.first_name + ' ' + $page.props.auth.user.last_name }}
                            </p>
                            <inertia-link class="nav-link text-secondary text-nowrap" href="#" @click="logout">
                                <i class="nav-icon fas fa-sign-out-alt"></i> Logout
                            </inertia-link>
                        </div>
                    </div>
                </div>
            </div>
        </nav>

        <section class="admin-main-content">
            <div class="content-wrapper">
                <section class="content-header">
                    <div class="container-fluid">
                        <div class="admin-header-container mb-2">
                            <slot name="header"></slot>
                            <slot name="breadcrumbs"></slot>
                        </div>
                    </div>
                </section>

                <section class="content">
                    <div class="container-fluid">
                        <flash-messages detail />
                        <slot />
                    </div>
                </section>
            </div>

            <footer class="admin-main-footer px-3">
                <div><strong>Copyright &copy; {{ moment().year() }}.</strong> All rights reserved.
                </div>
                <div v-if="$page.props.imageTag">
                    Build: {{ $page.props.imageTag }}
                </div>
            </footer>
        </section>
    </main>
    <ConfirmDialog></ConfirmDialog>
</template>

<script>
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/Admin/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
import ConfirmDialog from 'primevue/confirmdialog'
import moment from 'moment'

export default {
    components: {
        Dropdown,
        FlashMessages,
        Icon,
        Logo,
        MainMenu,
        ConfirmDialog,
    },
    created() {
        this.moment = moment;
    },
    mounted() {

        this.setGaInfo(this.$page.props)

        window.ResizeObserver = function () { return { observe: function () { }, disconnect: function () { }, unobserve: function () { } } };

        window.onpopstate = () => {
            this.$inertia.visit(window.location.href, { preserveState: false, preserveScroll: true });
        };
    },
    methods: {
        logout() {
            this.$inertia.post(route('logout'));
        },
    }
}
</script>

<style scoped>
.navbar-nav-scroll {
    overflow-y: inherit;
}
</style>
